import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ion_grid, {
      class: _normalizeClass(_ctx.$style['grid'])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { size: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.street,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.street) = $event)),
                  placeholder: _ctx.$t('global.fields.address.street'),
                  autocomplete: "off",
                  onInput: _ctx.emitValues
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, { size: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.number,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.number) = $event)),
                  placeholder: _ctx.$t('global.fields.address.number'),
                  autocomplete: "off",
                  onInput: _ctx.emitValues
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { size: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.zip,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zip) = $event)),
                  placeholder: _ctx.$t('global.fields.address.zip'),
                  autocomplete: "off",
                  onInput: _ctx.emitValues
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, { size: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.city,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.city) = $event)),
                  placeholder: _ctx.$t('global.fields.address.city'),
                  autocomplete: "off",
                  onInput: _ctx.emitValues
                }, null, 8, ["modelValue", "placeholder", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_select, {
                  modelValue: _ctx.country,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.country) = $event)),
                  class: _normalizeClass(_ctx.$style['select']),
                  placeholder: _ctx.$t('global.fields.address.country'),
                  autocomplete: "off",
                  onInput: _ctx.emitValues
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, key) => {
                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                        key: key,
                        value: key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(country.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "placeholder", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}